module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Learning about Ingredients"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e172",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Learning about\n              Ingredients")])]), _c('a', {
    attrs: {
      "id": "d0e172",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e172",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e172",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e172",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("When making your own marshmallows, you can control what goes into them so they are free of\n        artificial ingredients and preservatives, and are uniquely flavored. Because marshmallows\n        are delicately flavored, it’s important that you use high-quality ingredients. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e172",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e177",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Gelatin ")])]), _c('a', {
    attrs: {
      "id": "d0e177",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("The ingredient that gives marshmallows their popular texture is unflavored gelatin, which\n        can be found in most grocery stores in granulated form. I used Knox brand granulated\n        unflavored gelatin to test the recipes in this book. Using a vegan or kosher gelatin\n        substitute may provide very different results. You can use most gelatin sheets in these\n        recipes by substituting them in equal weight for the granulated variety. A tablespoon of\n        powdered gelatin weighs about 7 grams. Soften the gelatin sheets in cold water, dissolve\n        them in the cooked base, and proceed with the recipe. ")]), _vm._v(" "), _c('p', [_vm._v("Granulated gelatin is usually sold in pre-measured packets of approximately 2-1/2\n        teaspoons. Their weight is an average weight, and not every packet will contain exactly the\n        same amount of gelatin as another. You’ll need to empty the packets into a small dish and\n        then measure the gelatin for the recipes. ")]), _vm._v(" "), _c('p', [_vm._v("Gelatin is first mixed with a cold liquid for 5 or more minutes to soften it and separate\n        the granules (referred to in this book as blooming the gelatin), and then mixed with a hot\n        liquid to dissolve it so the gelatin doesn’t form clumps. Don’t skip this step. Depending on\n        the recipe, the softened gelatin mixture may be runny or very stiff. Don’t be alarmed by\n        this difference from one recipe to another. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e177",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e185",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cane Sugar Syrup vs. Light Corn Syrup ")])]), _c('a', {
    attrs: {
      "id": "d0e185",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "d0e185",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Most marshmallow recipes call for light corn syrup, which helps to eliminate sugar\n        crystallization when making marshmallows, because it contains invert sugar molecules that\n        stabilize regular sugar molecules. I’ve developed the recipes in this book using a\n        simple-to-make syrup, that I call ")]), _c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/ch08#msyrup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marshmallow Syrup")]), _vm._v(", consisting of cane sugar, water, and\n        cream of tartar, a naturally occurring acid that is a by-product of winemaking (readily\n        available in the baking section of grocery stores). The cream of tartar acts as a catalyst\n        in the reaction between sugar and water to form an invert sugar, stabilizing the sugar\n        molecules in the marshmallows the same way corn syrup would. It takes about half an hour to\n        make a 1-quart batch of the syrup, and it will keep at room temperature for up to 2 months. ")]), _vm._v(" "), _c('p', [_vm._v("Marshmallows made with Marshmallow Syrup are fluffier than those made with corn syrup and\n        are not gummy, and the flavors are cleaner. Because of the health questions surrounding the\n        use of corn syrup, I see no reason to use it when making marshmallows, although you can\n        substitute light corn syrup for the cane sugar syrup, if you prefer. ")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e194",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cane Sugar vs. Beet Sugar ")])]), _c('a', {
    attrs: {
      "id": "d0e194",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "d0e194",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("All of these recipes were tested using pure granulated cane sugar. Unless the bag says\n        “pure cane sugar,” you may be getting beet sugar, which has been reported to react\n        differently in many recipes. "), _c('sup', [_vm._v("[")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "footnote",
    attrs: {
      "href": "#/#ftn.d0e198",
      "id": "d0e198"
    }
  }, [_vm._v("1")])]), _vm._v("]")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e204",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Water ")])]), _c('a', {
    attrs: {
      "id": "d0e204",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("I know what you’re thinking: How silly is it to discuss water as an ingredient in a\n        cookbook? Well, marshmallows have only a few ingredients, so it’s vitally important that you\n        don’t use water that has an off-flavor or odor. If you use well water in your home, for\n        instance, the flavor of sulfur or other naturally occurring minerals in the water may come\n        through in the marshmallows. Use bottled water instead, if that is the case. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e204",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e208",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Fruits ")])]), _c('a', {
    attrs: {
      "id": "d0e208",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Fruit to be used in marshmallows should be fresh, locally grown, in season, and very ripe,\n        but not past its prime. If the fruit flavor you desire isn’t in season when you make\n        marshmallows, use the frozen variety of that fruit instead; your marshmallows will have a\n        significantly better flavor. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e208",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "fruit",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Fruits that are especially suited to\n        marshmallow making are strawberries, raspberries, blackberries, bananas, peaches,\n        nectarines, apricots, mangoes, and plums. For fruits that are grainy in texture, like pears\n        or apples, it’s best to use juice or nectar. ")])]), _c('a', {
    attrs: {
      "id": "fruit",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Do not use")])]), _vm._v(" these fresh fruits raw in marshmallows: figs, kiwifruits, papayas, pineapples,\n        guavas, mangoes, or prickly pears. Also, do not use fresh gingerroot. These items contain a\n        protease enzyme that destroys the protein in gelatin, preventing it from gelling, or causing\n        the gelatin to break down after the marshmallows are made. To deactivate the enzyme in all\n        of these fruits except kiwifruit, peel and chop the fruit and then bring it to a boil,\n        simmering it for 5 minutes. Do not use kiwifruit, raw or cooked, to make marshmallows. I\n        did, however, have good luck with uncooked frozen mango chunks. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "fruit",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("You can also use unsweetened fruit purees such as the top-quality Perfect Purees brand (see\n          ")]), _c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/ch16#resources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("resources")]), _vm._v(") for any of the marshmallow or\n        fluff recipes calling for pureed fruit. ")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e223",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cocoa ")])]), _c('a', {
    attrs: {
      "id": "d0e223",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("There are 2 types of unsweetened cocoa: natural and Dutch processed. Natural cocoa provides\n        a deep chocolate flavor, is slightly acidic, and reacts with baking soda to cause baked\n        goods to rise. Dutch-processed cocoa has a milder flavor, is reddish-brown, and is\n        alkalized, neutralizing the acid in cocoa. Baking powder is often used to leaven baked goods\n        that are made with Dutch-processed cocoa. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e223",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Buy a high-quality natural cocoa, such as Ghirardelli, or one of the great choices from\n        King Arthur or Penzeys Spices (see ")]), _c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/ch16#resources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("resources")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of colored marshmallows."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of colored marshmallows.",
      "src": "images/070402_coated_marsh_008.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('sup', [_vm._v("["), _c('a', {
    staticClass: "para",
    attrs: {
      "href": "#/#d0e198",
      "id": "ftn.d0e198"
    }
  }, [_vm._v("1")]), _vm._v("] ")]), _vm._v("“Sugar, Sugar: Cane\n            and Beet Share the Same Chemistry but Act Differently in the Kitchen,” Miriam Morgan,\n              "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("San Francisco Chronicle,")])]), _vm._v(" March 31, 1999. ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f1cba1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch05.vue
// module id = 78
// module chunks = 0